import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";
import AnimatedStat from "./AnimatedStat";

export default function StatsSection() {
  const { content } = useContent();
  const { t } = useLang();
  const stats = content?.stats || [];

  return (
    <section className="py-20 bg-gradient-to-b from-[var(--surface)] to-[var(--bg)] border-y border-white/5" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="overline text-center mb-10">{t("stats.title")}</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {stats.map((s, i) => (
            <AnimatedStat key={s.label} value={s.value} label={s.label} delay={i * 120} />
          ))}
        </div>
      </div>
    </section>
  );
}
